import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {Text, TextSize, TextTag} from '@Components/text';
import {Button, ButtonSize, ButtonType} from '@Components/button';
import type {BrandKitSetupPromptProps} from './brand-kit-setup-prompt.types';
import styles from './brand-kit-setup-prompt.module.scss';

/** What a brand kit surface shows a user who has no kit yet: one call to set one up. */
export function BrandKitSetupPrompt({onSetUp}: BrandKitSetupPromptProps): ReactElement {
  return (
    <div className={`${styles.setupPrompt} flex-column-align-center flex-content-center flex-1 gap-6`}>
      <span className={`${styles.setupPromptIconCircle} inline-flexbox flex-items-center flex-content-center corner-radius-full bg-brand-secondary-default`}>
        <Icon icon="icon-brands" size={IconSize.SIZE_ICON_24} type={IconType.NONE} shape={IconShape.NONE} className={styles.setupPromptIcon} />
      </span>
      <div className="flex-column-align-center gap-2 -text-align-center">
        <Text val={window.i18next.t('pmwjs_brand_kit_setup_prompt_title')} size={TextSize.LG} bold tag={TextTag.H3} className={styles.setupPromptTitle} />
        <Text val={window.i18next.t('pmwjs_brand_kit_setup_prompt_subtitle')} size={TextSize.MD} className="ct-neutral-secondary" />
      </div>
      <Button type={ButtonType.PRIMARY} size={ButtonSize.MEDIUM} icon="icon-plus" text={window.i18next.t('pmwjs_set_up_brand_kit')} onClick={onSetUp} />
    </div>
  );
}
